var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"presentation-cover-footer"},[_c('p',{staticClass:"presentation-cover-footer__slogan"},[_vm._v("One life. One planet. One way.")]),_c('p',{staticClass:"presentation-cover-footer__corner"},[_vm._t("corner")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }